import {createApp} from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { createPinia } from 'pinia'
import Vue3EasyDataTable from 'vue3-easy-data-table';
import Popper from "vue3-popper";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import 'vue3-easy-data-table/dist/style.css';
import '@vueform/multiselect/themes/default.css';

import './styles/reset.scss'

// import { vMaska } from "maska/vue";

const pinia = createPinia()
createApp(App)
    .component('EasyDataTable', Vue3EasyDataTable)
    .component("Popper", Popper)
    .use(pinia)
    .use(router)
    .use(store)
    // .directive("maska", vMaska)
    .mount('#app');

// User identify ---START---
import {jwtDecode} from "jwt-decode";

const token = localStorage.getItem('auth-token');
if (token) {
    store.state.user = jwtDecode(token);
    store.state.token = token;
}
// User identify ---END---